module.exports = __webpack_public_path__ + "static/media/Emotes-Impasto.b776cfb7.png";